import { render, staticRenderFns } from "./pbl2.vue?vue&type=template&id=b32622fc&scoped=true&"
import script from "./pbl2.vue?vue&type=script&lang=js&"
export * from "./pbl2.vue?vue&type=script&lang=js&"
import style0 from "./pbl2.vue?vue&type=style&index=0&id=b32622fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32622fc",
  null
  
)

export default component.exports